import { VBtn, VTextField } from "vuetify/components";

export default defineComponent({
  name: "PasswordInputField",
  props: VTextField.props,
  setup() {
    const show = ref(false);

    return {
      show,
    };
  },
  render() {
    return h(
      VTextField,
      { ...this.$attrs, ...this.$props, type: this.show ? "text" : "password" },
      {
        "append-inner": () => {
          return h(VBtn, {
            variant: "plain",
            size: "35",
            icon: this.show ? "visibility_off" : "visibility",
            onClick: () => {
              this.show = !this.show;
            },
          });
        },
      }
    );
  },
});
